// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SystemVersionsContextProperties = {
  translation_version?: string;
  notifications_state?: string;
  network_mcc?: string;
  network_operator_name?: string;
  network_mnc?: string;
  companion_notification_state?: string;
  client_environment: string;
  sim_carrier?: string;
  client_version: string;
  client: string;
  system_language?: string;
  other_components?: string;
  backend?: string;
  backend_version?: string;
  sim_mnc?: string;
  backend_server?: string;
  system_locale?: string;
  is_roaming?: boolean;
  app_adjust_id?: string;
  network_iso_country?: string;
  backend_environment?: string;
  crm_notification_state?: string;
  sim_iso_country?: string;
  sim_mcc?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/system_versions_context/jsonschema/1-0-6';
export const systemVersionsContextName = 'system_versions_context';
export class SystemVersionsContext extends BaseTrackingContext<SystemVersionsContextProperties> {
  constructor(properties: SystemVersionsContextProperties) {
    super(systemVersionsContextName, schema, properties);
  }
}
